/**
 * @type {Object}
 * @property {array}  data  Stock data
 */
const initialState = {
    stockMovingData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerStockMoving = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_STOCK_MOVING_DATA':
            var { data } = action;
            newState.stockMovingData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerStockMoving;